import { OFFICIAL_SOURCES } from '../officialSources';

const NTB_OFFICE = {
	id: 'ntb-kathmandu',
	name: 'Nepal Tourism Board — Tourist Service Center',
	address: 'Pradarshani Marg, Bhrikutimandap, Kathmandu',
	hours: 'Sun–Fri 09:00–17:00',
	mapsUrl: 'https://www.google.com/maps/search/?api=1&query=Nepal+Tourism+Board+Bhrikutimandap',
	whatToBring: ['Passport', 'Photos', 'NPR cash'],
	lastVerified: '2026-07-13',
};

const ACAP_POKHARA = {
	id: 'acap-pokhara',
	name: 'ACAP Permit Counter — Pokhara',
	address: 'Near Lakeside, Pokhara (ACAP office)',
	hours: 'Sun–Fri ~10:00–16:00',
	mapsUrl: 'https://www.google.com/maps/search/?api=1&query=ACAP+permit+office+Pokhara',
	whatToBring: ['Passport', 'NPR 3,000 cash', 'Passport photos'],
	lastVerified: '2026-07-13',
};

export const ABC_DEEP_CONTENT = {
	officeLocations: [NTB_OFFICE, ACAP_POKHARA],
	officialPdfs: [
		{ id: 'ntnc', label: 'NTNC — Annapurna Conservation Area', url: OFFICIAL_SOURCES.ntnc.url, source: OFFICIAL_SOURCES.ntnc },
		{ id: 'ntb-tims', label: 'NTB — TIMS information', url: OFFICIAL_SOURCES.ntb.url, source: OFFICIAL_SOURCES.ntb },
	],
	weatherByMonth: {
		source: 'Illustrative estimates for ABC (4,130m). Check mountain-forecast.com before trek.',
		lastVerified: '2026-07-13',
		months: [
			{ month: 'Oct', namcheHigh: 8, namcheLow: -5, gorakShepHigh: 5, gorakShepLow: -10, rainMm: 30, verdict: 'Best season — clear views', trek: 'Excellent' },
			{ month: 'Nov', namcheHigh: 5, namcheLow: -8, gorakShepHigh: 2, gorakShepLow: -15, rainMm: 15, verdict: 'Cold nights, great visibility', trek: 'Excellent' },
			{ month: 'Mar', namcheHigh: 10, namcheLow: 0, gorakShepHigh: 8, gorakShepLow: -5, rainMm: 50, verdict: 'Rhododendrons blooming', trek: 'Excellent' },
			{ month: 'Apr', namcheHigh: 14, namcheLow: 2, gorakShepHigh: 10, gorakShepLow: -2, rainMm: 60, verdict: 'Warm, some haze late month', trek: 'Good' },
			{ month: 'Jun', namcheHigh: 16, namcheLow: 8, gorakShepHigh: 12, gorakShepLow: 2, rainMm: 350, verdict: 'Monsoon — avoid', trek: 'Not recommended' },
		],
		forecastLinks: [
			{ label: 'Mountain Forecast — Annapurna Base Camp', url: 'https://www.mountain-forecast.com/peaks/Annapurna/forecasts/8091' },
		],
	},
	connectivity: {
		lastVerified: '2026-07-13',
		sim: [
			{ provider: 'Ncell', recommendation: 'Best coverage on ABC route', whereToBuy: 'Thamel or Pokhara Lakeside', trailSignal: 'Good to Chhomrong, weak above Himalaya' },
		],
		wifi: { kathmandu: 'Free at most hotels', trail: 'Paid WiFi at some teahouses — unreliable above 3,000m' },
	},
	altitudeSickness: {
		source: OFFICIAL_SOURCES.hra,
		lastVerified: '2026-07-13',
		goldenRules: [
			'Never ascend with worsening symptoms',
			'Descend immediately if symptoms become severe',
			'Acclimatize at Chhomrong and Himalaya — do not rush',
		],
		symptoms: { mild: 'Headache, nausea above 3,000m', severe: 'Ataxia, confusion — descend and evacuate' },
		prevention: ['Max 500m sleeping gain per day above 3,000m', 'Hydrate well', 'Avoid alcohol on trail'],
		aidPosts: [
			{ name: 'HRA Aid Post — Manang (circuit)', altitude: '3,540m', services: 'AMS advice (Annapurna circuit)' },
			{ name: 'Pokhara hospitals', altitude: '820m', services: 'Full emergency care post-trek' },
		],
	},
	emergencyContacts: [
		{ label: 'Tourist Police', number: '1144', note: 'Toll-free, English, 24/7', official: true },
		{ label: 'Police', number: '100', note: 'General emergency', official: true },
		{ label: 'Ambulance', number: '102', note: 'Pokhara/Kathmandu', official: true },
	],
	helicopterEvacuation: {
		lastVerified: '2026-07-13',
		costWithoutInsurance: 'USD 3,000–10,000+',
		procedure: ['Descend first', 'Call insurer emergency line', 'Coordinate via guide or Tourist Police 1144'],
		touristPolice: '1144',
	},
	porterGuide: {
		lastVerified: '2026-07-13',
		hiring: 'Hire through a TAAN-registered agency in Kathmandu or Pokhara.',
		costPerDay: 'USD 15–20/day porter, USD 20–30/day guide',
		weightLimit: '15 kg per porter',
		tipping: '10–15% at trek end',
		etiquette: ['One porter can serve two trekkers on standard routes', 'Carry your own daypack — porter takes duffel only'],
	},
	licensedAgencies: {
		verifyUrl: 'https://www.taan.org.np/',
		verifyLabel: 'TAAN — Trekking Agencies Association of Nepal',
		howToVerify: ['Check TAAN membership', 'Visit physical office in Pokhara Lakeside'],
		redFlags: ['Airport touts', '100% upfront cash', 'No written itinerary'],
		agencies: [
			{ name: 'Pokhara trekking agencies (Lakeside)', area: 'Pokhara', specialty: 'ABC group & private treks' },
		],
	},
	gearRentalShops: [
		{ name: 'Thamel gear shops', area: 'Kathmandu', items: 'Sleeping bags, jackets, poles', rates: '$2–3/day' },
		{ name: 'Pokhara Lakeside shops', area: 'Pokhara', items: 'Last-minute gear', rates: 'Similar to Thamel' },
	],
	gpxMap: {
		description: 'Annapurna Base Camp via Chhomrong — standard teahouse route.',
		resources: [
			{ label: 'OpenStreetMap — Annapurna region', url: 'https://www.openstreetmap.org/#map=11/28.530/83.878', type: 'interactive_map' },
			{ label: 'Waymarked Trails — ABC', url: 'https://hiking.waymarkedtrails.org/#route?r=656484', type: 'gpx_route' },
		],
	},
	offlineDownloads: [
		{ id: 'packing', label: 'Packing checklist', type: 'checklist' },
		{ id: 'documents', label: 'Documents wallet', type: 'checklist' },
		{ id: 'emergency', label: 'Emergency contacts', type: 'text' },
	],
	travelerFaqs: [
		{ q: 'ABC or EBC for first trek?', a: 'ABC — shorter, lower altitude, no Lukla flight risk. EBC if you want the iconic Everest experience and can commit 12–14 days.', category: 'planning' },
		{ q: 'Are the Ulleri steps really that bad?', a: '3,300+ stone steps on day 1 if you start from Nayapul via Ulleri. Consider Ghandruk route or jeep to Ulleri to skip the worst section.', category: 'trail' },
		{ q: 'Can I trek ABC solo?', a: 'Yes — well-marked trail with frequent teahouses. Solo female trekkers commonly do ABC. Share itinerary with someone at home.', category: 'safety' },
	],
};
